import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  NgModule,
  NO_ERRORS_SCHEMA,
  provideAppInitializer,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { HttpConfigInterceptor } from './services/interceptor/httpconfig.interceptor';
import { environment } from 'src/environments/environment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';
import { Loader } from '@googlemaps/js-api-loader';
import { GoogleMapsModule } from '@angular/google-maps';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import Lara from '@primeng/themes/lara';
import Material from '@primeng/themes/material';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { JSChartingModule } from './jscharting/jscharting.module';


import { MSAL_BROADCAST_CONFIG, MsalGuardConfiguration, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { msalInstance } from './msal-instance';


export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId,
      authority: environment.authority,
      redirectUri: environment.appUrl,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: isIE,
    },
  });
}

// import { PrettyDatePipe } from './pipes/pretty-date.pipe';
// import { PrettyDateTimePipe } from './pipes/pretty-date-time.pipe';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;
// const config: MsalGuardConfiguration = {
//   interactionType: 'redirect',
//   authRequest: {
//     scopes: ['user.read']
//   }
// };


// Create a default MsalGuardConfiguration
const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect, // Set to your preferred interaction type
  authRequest: {
    scopes: ['openid', 'profile', 'user.read'], // Set to your required scopes
  },
};
// Create a default MsalInterceptorConfiguration
const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect, // Set to your preferred interaction type
  protectedResourceMap: new Map([['https://graph.microsoft.com/v1.0/me', ['user.read']]]), // Set to your protected resources
};


export function initMsalFactory(msal: MsalService) {
  return async () => {
    // Make sure Angular waits for MSAL to initialize
    await msal.instance.initialize();

    // Optional: low-level tap to prove events are coming through
    msal.instance.addEventCallback((m) => {
      console.log('[MSAL event]', m.eventType, m);
      // You should see HANDLE_REDIRECT_START/END then LOGIN_SUCCESS after redirect
    });
  };
}

@NgModule({
  declarations: [
    AppComponent,
    // PrettyDatePipe,
    // PrettyDateTimePipe,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      timeOut: 2000,
    }),

    MsalModule.forRoot(
      // new PublicClientApplication({
      //   auth: {
      //     clientId: environment.clientId,
      //     authority: environment.authority,
      //     redirectUri: environment.appUrl,
      //   },
      //   cache: {
      //     cacheLocation: 'localStorage',
      //     storeAuthStateInCookie: isIE,
      //   },
      // }),

      // MSALInstanceFactory(), // not working

      msalInstance,
      msalGuardConfig,
      msalInterceptorConfig
    ),
    NgxGpAutocompleteModule,
    GoogleMapsModule,
    JSChartingModule,

  ],
  providers: [
    ConfirmationService,
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    {
      provide: Loader,
      useValue: new Loader({
        apiKey: environment.googlePlaceApiKey,
        libraries: ['places'],
      }),
    },
    {
      provide: MSAL_BROADCAST_CONFIG,
      useValue: { eventsToReplay: 5 }  // replays last 2 events on new subscriptions
    },
    // { provide: APP_INITIALIZER, useFactory: initMsalFactory, deps: [MsalService], multi: true },
    provideAppInitializer(() => inject(MsalService).initialize()),

    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: { darkModeSelector: '.dark-theme' },
      },
    }),
    provideHttpClient(withInterceptorsFromDi()),

  ],
})
export class AppModule { }
